import React, { Suspense, useEffect } from "react";
//prettier-ignore
import { Route, Redirect, Switch, useLocation, withRouter } from "react-router-dom";
import { GlobalStyles } from "twin.macro";
import { StyledApp } from "./styles/styledApp";
import { Navbar } from "./components";

const Home = React.lazy(() => import("./pages/HomePage/Home"));
const Partner = React.lazy(() => import("./pages/PartnerPage/Partner"));
const Process = React.lazy(() => import("./pages/ProcessPage/Process"));
const Pricing = React.lazy(() => import("./pages/PricingPage/Pricing"));
const About = React.lazy(() => import("./pages/AboutPage/About"));
const Support = React.lazy(() => import("./pages/SupportPage/Support"));
const Offer = React.lazy(() => import("./pages/OffersPage/Offer"));
const Offer1 = React.lazy(() => import("./pages/OffersPage/Offer1"));
const Careers = React.lazy(() => import("./pages/CareerPage/Career"));
const Ads = React.lazy(()=> import("./pages/AdPage/Ad"))
// const Complaint = React.lazy(() => import("./pages/ComplaintPage/Complaint"));


function _ScrollToTop(props) {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return props.children;
}
const ScrollToTop = withRouter(_ScrollToTop);

function App() {

  return (
    <StyledApp>
      <GlobalStyles />      
      <ScrollToTop>
        <Suspense fallback={<div>Loading...</div>}>
          <Switch>
          <Route exact path="/signup/:city/:referred_partner_mobile/:code" component={Offer} />
          <Route exact path="/signup/:apartments/:coupon" component={Offer1} />
          <Route exact path = '/car-cleaning-subscription' component={Ads}/>
          <Redirect exact from="/" to="/home" />
            <div>
            <Navbar />
            <Route exact path="/home" component={Home} />
            <Route exact path="/partners" component={Partner} />
            <Route exact path="/process" component={Process} />
            <Route exact path="/pricing" component={Pricing} />
            <Route exact path="/about" component={About} />
            <Route exact path="/support" component={Support} />
            <Route
              exact
              path="/subscribe"
              component={() => {
                window.location.replace("http://wa.me/919384016213?text=Hi, I would like to Subscribe");
                return null;
              }}
            />
            <Route
            exact
            path="/careers"
            component={Careers} 
            /> 
            {/* <Route exact path="/complaint" component={Complaint} /> */}
            </div>
          </Switch>
        </Suspense>
      </ScrollToTop>
    </StyledApp>
  );
}

export default App;
